import { Container, Typography, Box, Grid, Card, CardContent, CardMedia, Button } from '@mui/material'
import EngineeringIcon from '@mui/icons-material/Engineering'
import BuildIcon from '@mui/icons-material/Build'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'

const services = [
  {
    id: 1,
    title: 'Solar Installation',
    description: 'Professional installation of solar panels, inverters, and battery systems for residential and commercial properties. We ensure optimal placement for maximum energy generation.',
    icon: <EngineeringIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=600&auto=format&fit=crop&q=60'
  },
  {
    id: 2,
    title: 'System Maintenance',
    description: 'Regular checkups and maintenance to keep your solar energy system running at peak efficiency. We inspect wiring, connections, and performance metrics.',
    icon: <BuildIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=600&auto=format&fit=crop&q=60'
  },
  {
    id: 3,
    title: 'Panel Cleaning',
    description: 'Dust and debris can reduce energy output by up to 25%. Our professional cleaning service ensures your panels are spotless and performing efficiently.',
    icon: <CleaningServicesIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    image: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?q=80&w=600&auto=format&fit=crop'
  },
  {
    id: 4,
    title: 'Technical Consultation',
    description: 'Not sure what system you need? Our experts provide free consultation to assess your energy requirements and recommend the best solar solution for your budget.',
    icon: <SupportAgentIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&auto=format&fit=crop&q=60'
  }
]

export default function ServicesPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="primary">
          Our Services
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
          Comprehensive solar energy solutions tailored to your needs. From installation to maintenance, Starwave Energy has you covered.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {services.map((service) => (
          <Grid item xs={12} md={6} key={service.id}>
            <Card sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, height: '100%', elevation: 2 }}>
              <CardMedia
                component="img"
                sx={{ width: { xs: '100%', sm: 200 }, height: { xs: 200, sm: 'auto' } }}
                image={service.image}
                alt={service.title}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {service.icon}
                    <Typography component="div" variant="h5" sx={{ ml: 2, fontWeight: 'bold' }}>
                      {service.title}
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    {service.description}
                  </Typography>
                </CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 2 }}>
                  <Button size="small" color="primary" sx={{ fontWeight: 'bold' }}>
                    Learn More
                  </Button>
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}